import { HomeInternetTariffSliceItem } from '@/store/slice/home-internet.slice';
import { HomeInternetTariffMappedOptions } from './helpers.types';

export const homeInternetTariffSliceMapper = (tariff: HomeInternetTariffMappedOptions) : HomeInternetTariffSliceItem => {
  return {
    id: tariff.id,
    shpd_id: tariff.shpd_id,
    shpd_id_convergent: tariff.shpd_id_convergent,
    name: tariff.name,
    localized_name: tariff.localized_name,
    defaultOptionsHomeInternet: tariff.defaultOptionsHomeInternet,
  }
}
